/* eslint-disable */
import LazySizes from 'lazysizes';
import Unveilhooks from 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import Modernizr from 'modernizr';
/* eslint-enable */
import { gsap, ScrollToPlugin } from 'gsap/all';

import { onDocumentReady } from './utils';

// Components
import Accordion from '@src/components/accordion';
import ColorToggle from '@src/components/color-toggle';
import Filters from '@src/components/filters';
import Menu from '@src/components/menu';
import ScrollTop from '@src/components/scroll-top';
import ToggleDates from '@src/components/toggle-dates';
import Links from '@src/components/links';
import ShaderBG from '@src/components/shader-bg';
import Weather from '@src/components/weather';
import Newsletter from '@src/components/newsletter';

onDocumentReady(() => {
  new Links();
  gsap.registerPlugin(ScrollToPlugin);

  if (document.querySelector('.spectrum__canvas')) {
    new ShaderBG();
  }

  if (document.querySelector('.js--more-button')) {
    new ToggleDates();
  }

  if (document.querySelector('.js--scroll-top')) {
    new ScrollTop();
  }

  if (document.querySelector('.js--color-toggle')) {
    new ColorToggle('.js--color-toggle');
  }

  if (document.querySelector('.js--accordion')) {
    new Accordion();
  }

  if (document.querySelector('.js-filters-neighbors')) {
    const args = {
      itemSelector: '.accordion-list__item',
      tagSelector: '.accordion__tag-item',
      containerSelector: '.neighborhood__h-divider',
      perPage: 15,
    };

    new Filters(args);
  }

  if (document.querySelector('.js-filters-events')) {
    const args = {
      itemSelector: '.event-list__item',
      tagSelector: '.tease__tag-link',
      containerSelector: '.event-filters',
      perPage: 6,
    };

    new Filters(args);
  }

  if (document.querySelector('.js-filters-archive')) {
    const args = {
      itemSelector: '.archive-list__item',
      tagSelector: '.tease__tag-link',
      containerSelector: '.js-filters-archive',
      perPage: 10,
    };

    new Filters(args);
  }

  const MENU_CLASS = '.js--menu';
  if (document.querySelector(MENU_CLASS)) {
    new Menu(MENU_CLASS);
  }

  if (document.querySelector('.js-modal-gallery')) {
    import(/* webpackChunkName: "modal-gallery" */ '@src/components/modal-gallery').then(module => {
      const ModalGallery = module.default;
      new ModalGallery();
    });
  }

  if (document.querySelector('.js-hang-punc')) {
    import(/* webpackChunkName: "hang-punctuation" */ '@src/components/hang-punctuation').then(
      module => {
        const HangPunctuation = module.default;
        new HangPunctuation();
      },
    );
  }

  if (document.querySelector('.wp-block-table')) {
    import(/* webpackChunkName: "hang-punctuation" */ '@src/components/tables').then(module => {
      const Tables = module.default;
      new Tables();
    });
  }

  if (document.getElementById('weather-block')) {
    new Weather();
  }

  if (document.getElementById('body-newsletter')) {
    const bodyArgs = {
      formId: 'mailchimp-body',
    };

    new Newsletter(bodyArgs);
  }

  if (document.getElementById('sidebar-newsletter')) {
    const sidebarArgs = {
      formId: 'mailchimp-sidebar',
    };

    new Newsletter(sidebarArgs);
  }

  const footerArgs = {
    formId: 'mailchimp-footer',
  };

  new Newsletter(footerArgs);

  // This is an example of how to do code splitting. The JS in this
  // referenced file will only be loaded on that page. Good for
  // when you have a large amount of JS only needed in one place
  //
  //  if (document.querySelector('#js-process')) {
  //    import(/* webpackChunkName: "process" */ './pages/process')
  //      .then(module => {
  //        const Process = module.default;
  //        this.process = new Process();
  //      });
  //  }
});
